import { setHeaders } from "../../utils/fetch";

const getters = {
  tenant: state => state.tenant,
  tenants: state => state.tenants
};

const actions = {
  createTenant(context, data) {
    return new Promise((resolve, reject) => {
      fetch(`${process.env.VUE_APP_BASE_URL.toCorrectDomain()}/api/tenant`, {
        method: "post",
        headers: setHeaders(
          {
            "Content-Type": "application/json"
          },
          context.getters.user
        ),
        body: JSON.stringify(data)
      })
        .then(res => {
          return res.json();
        })
        .then(function(data) {
          context.commit("addTenant", data);
          resolve(data);
        })
        .catch(e => {
          window.console.error(e);
          reject();
        });
    });
  },
  updateTenant(context, data) {
    return new Promise((resolve, reject) => {
      fetch(
        `${process.env.VUE_APP_BASE_URL.toCorrectDomain()}/api/tenant/${
          data.tenantId
        }`,
        {
          method: "put",
          headers: setHeaders(
            {
              "Content-Type": "application/json"
            },
            context.getters.user
          ),
          body: JSON.stringify(data)
        }
      )
        .then(res => {
          return res.json();
        })
        .then(function(data) {
          context.commit("setTenant", data);
          resolve(data);
        })
        .catch(e => {
          window.console.error(e);
          reject();
        });
    });
  },
  deleteTenant(context, data) {
    return new Promise((resolve, reject) => {
      fetch(
        `${process.env.VUE_APP_BASE_URL.toCorrectDomain()}/api/tenant/${
          data.tenantId
        }`,
        {
          method: "delete",
          headers: setHeaders(
            {
              "Content-Type": "application/json"
            },
            context.getters.user
          ),
          body: JSON.stringify(data)
        }
      )
        .then(res => {
          return res.json();
        })
        .then(function(data) {
          context.commit("setTenants", data);
          resolve(data);
        })
        .catch(e => {
          window.console.error(e);
          reject();
        });
    });
  },
  loadTenant(context, tenantId) {
    return new Promise((resolve, reject) => {
      if (context.getters.tenant.tenantId === tenantId) {
        resolve(context.getters.tenant);
        return;
      }

      fetch(
        `${process.env.VUE_APP_BASE_URL.toCorrectDomain()}/api/tenant/${tenantId}`,
        {
          method: "get",
          headers: setHeaders(
            {
              "Content-Type": "application/json"
            },
            context.getters.user
          )
        }
      )
        .then(res => {
          return res.json();
        })
        .then(function(data) {
          context.commit("setTenant", data);
          resolve(data);
        })
        .catch(e => {
          context.commit("setTenant", []);
          window.console.error(e);
          reject();
        });
    });
  },
  loadTenants(context) {
    return new Promise((resolve, reject) => {
      fetch(`${process.env.VUE_APP_BASE_URL.toCorrectDomain()}/api/tenant`, {
        method: "get",
        headers: setHeaders(
          {
            "Content-Type": "application/json"
          },
          context.getters.user
        )
      })
        .then(res => {
          return res.json();
        })
        .then(function(data) {
          context.commit("setTenants", data);
          resolve(data);
        })
        .catch(e => {
          context.commit("setTenant", { name: "pinwall" });
          window.console.error(e);
          reject();
        });
    });
  }
};

const mutations = {
  setTenant(state, tenant) {
    if (!tenant.tenantId) {
      tenant.tenantId = tenant.name;
    }
    state.tenant = tenant;
    state.tenants = tenant.tenants;
  },
  setTenants(state, tenants) {
    state.tenants = tenants;
  },
  addTenant(state, tenants) {
    state.tenants.push(tenants);
  }
};

export default {
  state: initializeState(),
  mutations,
  actions,
  getters
};

function initializeState() {
  return {
    tenant: {
      name: "pinwall",
      tenantId: "pinwall",
      imageUrl:
        "//pinwall.io/cdn/pinwallusers/a6d472f46975a30079d7e319-logo-std.png"
    },
    tenants: []
  };
}
